import React from 'react'
import styles from './TaskCompletion.module.scss';
import {TaskCompletionData } from '../../../../data/taskCompletionData';
import Avatar from 'components/Avatar/Avatar';


export default function TaskCompletion() {

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const renderBubble = (data: any, month : number)=> {
      let date =  data.date.split('/');
      if(month !== (parseInt(date[1]) - 1)){
        return
      }
      let x = ((parseInt(date[0])/30) * 100) + '%';

      let bubbleStyle = {
        left: x,
        background: data.volume === 1 ? 'var(--gray-100)' : 'var(--gray-500)',
        width: (data.volume * 2) + 'rem', 
        transform: `translate( -${x} , -50%)`
      } as React.CSSProperties;

      return (
        <div
          style={bubbleStyle}
          className={styles.bubble}
        ></div>
      );
    }

  return (
    <div className="widget">
      {/* header */}
      <div className="d-flex align-items-center justify-content-between">
        <h3 className="widget-title">Task Completion</h3>

        <button className="btn btn-flat text-white flex-center">
          View Report
          <i className="icon-arrow-right text-5c ml-2"></i>
        </button>
      </div>
      {/* Header */}

      <h6 className="text-gray-400 fw-300">Description</h6>

      <table className={styles.taskTable}>
        <tbody>
          {TaskCompletionData.map((task, ti) => (
            <tr key={ti}>
              <td className={styles.userCol}>
                <div className="d-flex align-items-center">
                  <Avatar src={task.user.image} />
                  <div className="d-inline-block ml-2">
                    <h5 className="fw-300 mb-0">{task.user.fullName}</h5>
                    <small className="fw-300">{task.user.designation}</small>
                  </div>
                </div>
              </td>

              {months.map((month, i) => (
                <td key={month}>
                  {task.data.map((data, ti) => <div key={ti}>{renderBubble(data, i)}</div>)}
                </td>
              ))}
            </tr>
          ))}

          <tr>
            <td></td>
            {months.map((month) => (
              <td key={month}>
                <span className={styles.footMonth}>{month}</span>
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
